<template lang="pug">
.wrap
	template(v-if="!isLoggedIn")
		AuthCard(type="paymentFlow" @close="$emit('close')")
	Suspense(v-else)
		ProductsList(:preSelectedProduct="product" @close="$emit('close')")
</template>

<script setup lang="ts">
import { useUserStore } from '~/pinia/userStore'

const { isLoggedIn } = useAuth()
const userStore = useUserStore()
const { hasPremiumSub } = storeToRefs(userStore)

const emit = defineEmits(['close'])

defineProps({
	product: {
		type: Object,
		required: false
	}
})

watch(hasPremiumSub, (newValue) => {
	if (newValue) {
		emit('close')
		const localePath = useLocalePath()
		navigateTo(localePath('/karaoke'))
	}
})

const route = useRoute()

onMounted(() => {
	if (!isLoggedIn.value && route.query.skip_redirect !== 'true') {
		navigateTo({ ...route, query: { ...route.query, skip_redirect: 'true' } }, { replace: true })
	}
})
</script>

<style lang="sass" scoped>
.products-modal-wrap
	background: $color-grey-80
	border-radius: $radius-default
	padding: $spacing-16
	@media (min-width: $tablet)
		padding: $spacing-40
</style>
